import React from 'react';
import PropTypes from 'prop-types';
import {
  LoadingSpinnerContainer,
  Spinner,
  Heading,
  Body,
} from './styles/LoadingSpinnerStyled';

const LoadingSpinner = ({ title, displayRow, spinnerSmall, body }) => {
  return (
    <LoadingSpinnerContainer row={displayRow}>
      <Spinner small={spinnerSmall} />
      <Heading row={displayRow}>{title}</Heading>
      {body && <Body>{body}</Body>}
    </LoadingSpinnerContainer>
  );
};

LoadingSpinner.propTypes = {
  title: PropTypes.string,
  displayRow: PropTypes.bool,
  spinnerSmall: PropTypes.bool,
  body: PropTypes.string,
};

LoadingSpinner.defaultProps = {
  title: 'Cargando...',
  displayRow: false,
  spinnerSmall: false,
  body: '',
};

export default LoadingSpinner;
